export default __webpack_public_path__ + "static/taskdef4-db2a19cd0a4adcdd4aa8a61946878243.png";